import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';
import { CachedCallService } from './cached-call.service';

import { Translation } from '../../entities/translation';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class TranslationService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly translationsBaseUrl:string = `${Settings.apiUrl}/v1/Translations`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getTranslationByTranslationKeyAndLanguage(translationKeyId:string, languageId:number): Promise<Translation> {

    let translationUrl:string = `${TranslationService.translationsBaseUrl}/RCC.GetTranslation(TranslationKeyId=${translationKeyId},LanguageId=${languageId})/`;

    return this.http.get(translationUrl)
      .toPromise()
      .then(response => response.json())
      .then(translation => {
        return translation;
      });
  }

  getTranslationByTranslationKeyName(name:string, languageId:number): Promise<Translation> {

    // ODataBuilder automatically checks for string that matches a Guid and treats them as a Guid (no quotes in OData params)
    // Because the TranslationKey.Name is a string data type but matches a Guid the ODataBuilder can't be used at this point b/c it'll break on the server during the compare
    let translationUrl:string = `${TranslationService.translationsBaseUrl}/?$filter=TranslationKey/Name eq '${name}' and LanguageId eq ${languageId}&$expand=TranslationKey,Language`;

    return this.http.get(translationUrl)
      .toPromise()
      .then(response => response.json().value)
      .then(translations => {
        return translations[0];
      });
  }

  createTranslation(translation: Translation): Promise<Translation> {
    let translationUrl: string = `${Settings.apiUrl}/v1/Translations`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete translation.TranslationId;
    delete translation.TranslationKey;
    delete translation.Language;

    return this.http.post(translationUrl, JSON.stringify(translation), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchTranslation(translation: Translation): Promise<null> {

    let translationUrl: string = `${Settings.apiUrl}/v1/Translations(${translation.TranslationId})`;

    delete translation.TranslationKey;
    delete translation.Language;

    return this.http.patch(translationUrl, JSON.stringify(translation), this.options)
      .toPromise()
      .then(response => response);
  }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/translation.service.ts